import { Icon } from "semantic-ui-react";

import "modules/DealerReports/components/DealerUsersReport/components/DealerUserReportsCustomHeader/DealerUserReportsCustomHeader.scss";

import type { HeaderType } from "components";
import type { ReportRow } from "modules/DealerReports/components/DealerUsersReport";

export const DealerUserReportsCustomHeader = ({ headers }: { headers: HeaderType<ReportRow>[] }) => {
  const customHeaderOptions = headers.map(({ column, sortingState, toggleSorting, renderHeader }) => (
    <th key={column.id} className="DealerUserReportsCustomHeader">
      <div className="title-sorting-icons-header">
        <div className="title">
          <strong>{renderHeader()}</strong>
          <Icon className={sortingState?.desc ? "caret down" : "caret up"} onClick={toggleSorting} />
        </div>
      </div>
    </th>
  ));

  return <tr>{customHeaderOptions}</tr>;
};
